var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { isEmpty, isNil } from 'lodash-es';
import { SDS_SEARCH_CUSTOM_EVENTS } from './sds-search-custom-events';
import { createBoundEventHandlers, } from '../utilities/events/input-native-events';
/**
 * @fires sds.search.changed - Event is fired when change is detected.
 * @fires sds.search.input - Event is fired when input occurs.
 * @fires sds.search.cleared - Event is fired when the search is cleared.
 * @fires sds.search.submit - Event is fired when the search is submitted (Enter key).
 * @fires keyup - Native keyup event from the input element.
 * @fires keydown - Native keydown event from the input element.
 * @fires keypress - Native keypress event from the input element.
 */
let SdsSearch = (() => {
    var _a, _SdsSearch_value_accessor_storage, _SdsSearch_focused_accessor_storage, _SdsSearch_inNavigation_accessor_storage, _SdsSearch_inHeader_accessor_storage, _SdsSearch_placeholder_accessor_storage;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _focused_decorators;
    let _focused_initializers = [];
    let _focused_extraInitializers = [];
    let _inNavigation_decorators;
    let _inNavigation_initializers = [];
    let _inNavigation_extraInitializers = [];
    let _inHeader_decorators;
    let _inHeader_initializers = [];
    let _inHeader_extraInitializers = [];
    let _placeholder_decorators;
    let _placeholder_initializers = [];
    let _placeholder_extraInitializers = [];
    return _a = class SdsSearch extends _classSuper {
            /**
             * The value of this search input.
             * @attr
             */
            get value() { return __classPrivateFieldGet(this, _SdsSearch_value_accessor_storage, "f"); }
            set value(value) { __classPrivateFieldSet(this, _SdsSearch_value_accessor_storage, value, "f"); }
            /**
             * True if component is focused.
             * @attr
             */
            get focused() { return __classPrivateFieldGet(this, _SdsSearch_focused_accessor_storage, "f"); }
            set focused(value) { __classPrivateFieldSet(this, _SdsSearch_focused_accessor_storage, value, "f"); }
            get inNavigation() { return __classPrivateFieldGet(this, _SdsSearch_inNavigation_accessor_storage, "f"); }
            set inNavigation(value) { __classPrivateFieldSet(this, _SdsSearch_inNavigation_accessor_storage, value, "f"); }
            get inHeader() { return __classPrivateFieldGet(this, _SdsSearch_inHeader_accessor_storage, "f"); }
            set inHeader(value) { __classPrivateFieldSet(this, _SdsSearch_inHeader_accessor_storage, value, "f"); }
            /**
             * Placeholder used if this search input is empty.
             * @attr
             */
            get placeholder() { return __classPrivateFieldGet(this, _SdsSearch_placeholder_accessor_storage, "f"); }
            set placeholder(value) { __classPrivateFieldSet(this, _SdsSearch_placeholder_accessor_storage, value, "f"); }
            constructor() {
                super();
                _SdsSearch_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, void 0));
                _SdsSearch_focused_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _focused_initializers, false)));
                _SdsSearch_inNavigation_accessor_storage.set(this, (__runInitializers(this, _focused_extraInitializers), __runInitializers(this, _inNavigation_initializers, false)));
                _SdsSearch_inHeader_accessor_storage.set(this, (__runInitializers(this, _inNavigation_extraInitializers), __runInitializers(this, _inHeader_initializers, false)));
                _SdsSearch_placeholder_accessor_storage.set(this, (__runInitializers(this, _inHeader_extraInitializers), __runInitializers(this, _placeholder_initializers, '')));
                /**
                 * Reference to the input element
                 */
                this.inputElement = (__runInitializers(this, _placeholder_extraInitializers), null);
                this.needsChangeOnBlur = false;
                this.eventHandlers = createBoundEventHandlers(this, {});
            }
            handleInput() {
                this.value = this.convertValue(this.getInput().value);
                // Reset needsChangeOnBlur if user types after clearing
                if (this.needsChangeOnBlur && this.value !== this.emptyValue()) {
                    this.needsChangeOnBlur = false;
                }
                this.dispatchEvent(new CustomEvent(SDS_SEARCH_CUSTOM_EVENTS.INPUT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            handleSubmit(event) {
                event.preventDefault();
                this.dispatchEvent(new CustomEvent(SDS_SEARCH_CUSTOM_EVENTS.SUBMIT, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            handleFocus() {
                this.focused = true;
            }
            handleBlur() {
                if (this.needsChangeOnBlur) {
                    this.handleChanged();
                    this.needsChangeOnBlur = false;
                }
                this.focused = false;
            }
            handleChanged() {
                this.dispatchEvent(new CustomEvent(SDS_SEARCH_CUSTOM_EVENTS.CHANGE, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            handleKeyDown(event) {
                if (event.key === 'Enter') {
                    this.handleSubmit(event);
                }
            }
            handleClear() {
                const wasFocused = this.focused;
                const emptyValue = this.emptyValue();
                // Store the current state before any changes
                const hadValue = this.value !== emptyValue;
                this.focused = true;
                this.value = emptyValue;
                // If we had a value (regardless of focus state), we need a change event
                if (hadValue) {
                    // For focused case, we'll rely on the native change event
                    if (!wasFocused) {
                        this.needsChangeOnBlur = true;
                    }
                }
                this.getInput().focus();
                this.dispatchEvent(new CustomEvent(SDS_SEARCH_CUSTOM_EVENTS.CLEARED, {
                    detail: { value: this.value },
                    bubbles: false,
                    composed: false,
                }));
            }
            showClear() {
                return !isNil(this.value) && !isEmpty(this.value);
            }
            renderClear() {
                if (this.showClear()) {
                    return html `
                <sds-button
                    class="sds-search__action"
                    type="secondary"
                    size="sm"
                    icon="close"
                    rounded
                    @mousedown="${(e) => e.preventDefault()}"
                    @click="${() => this.handleClear()}"
                ></sds-button>
            `;
                }
            }
            renderInput() {
                return html `
            <input
                type="text"
                class="sds-search__element"
                part="sds-search-element"
                placeholder="${this.placeholder}"
                value="${this.value}"
                @input="${() => this.handleInput()}"
                @focus="${() => this.handleFocus()}"
                @blur="${() => this.handleBlur()}"
                @change="${() => this.handleChanged()}"
                @keydown="${(e) => this.handleKeyDown(e)}"
            />
        `;
            }
            firstUpdated() {
                this.inputElement = this.getInput();
                this.eventHandlers.setupEventListeners(this.inputElement);
            }
            disconnectedCallback() {
                super.disconnectedCallback();
                this.eventHandlers.removeEventListeners(this.inputElement);
            }
            updated(changedProperties) {
                if (changedProperties.has('focused') && this.focused) {
                    this.getInput().focus();
                }
                if (changedProperties.has('value')) {
                    this.getInput().value = (this.value || '').toString();
                }
            }
            getClasses() {
                return classMap({
                    'sds-search': true,
                    'sds-search--focused': this.focused,
                    'sds-search--in-navigation': this.inNavigation,
                    'sds-search--in-header': this.inHeader,
                });
            }
            addEventListener(type, listener, options) {
                super.addEventListener(type, listener, options);
            }
        },
        _SdsSearch_value_accessor_storage = new WeakMap(),
        _SdsSearch_focused_accessor_storage = new WeakMap(),
        _SdsSearch_inNavigation_accessor_storage = new WeakMap(),
        _SdsSearch_inHeader_accessor_storage = new WeakMap(),
        _SdsSearch_placeholder_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _value_decorators = [property({ type: String || Number, reflect: true })];
            _focused_decorators = [property({ type: Boolean })];
            _inNavigation_decorators = [property({ type: Boolean, attribute: 'in-navigation' })];
            _inHeader_decorators = [property({ type: Boolean, attribute: 'in-header' })];
            _placeholder_decorators = [property({ type: String })];
            __esDecorate(_a, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
            __esDecorate(_a, null, _focused_decorators, { kind: "accessor", name: "focused", static: false, private: false, access: { has: obj => "focused" in obj, get: obj => obj.focused, set: (obj, value) => { obj.focused = value; } }, metadata: _metadata }, _focused_initializers, _focused_extraInitializers);
            __esDecorate(_a, null, _inNavigation_decorators, { kind: "accessor", name: "inNavigation", static: false, private: false, access: { has: obj => "inNavigation" in obj, get: obj => obj.inNavigation, set: (obj, value) => { obj.inNavigation = value; } }, metadata: _metadata }, _inNavigation_initializers, _inNavigation_extraInitializers);
            __esDecorate(_a, null, _inHeader_decorators, { kind: "accessor", name: "inHeader", static: false, private: false, access: { has: obj => "inHeader" in obj, get: obj => obj.inHeader, set: (obj, value) => { obj.inHeader = value; } }, metadata: _metadata }, _inHeader_initializers, _inHeader_extraInitializers);
            __esDecorate(_a, null, _placeholder_decorators, { kind: "accessor", name: "placeholder", static: false, private: false, access: { has: obj => "placeholder" in obj, get: obj => obj.placeholder, set: (obj, value) => { obj.placeholder = value; } }, metadata: _metadata }, _placeholder_initializers, _placeholder_extraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a;
})();
export { SdsSearch };
